import { ListaPrecoResolvida } from '../interfaces/lista-preco-resolvida';
import { Produto } from '../interfaces/produto';

/**
 * Preço do produto para a lista/tabela: par lista+tabela → só a lista → só a tabela → preço do
 * cadastro. Mesma regra da venda-dialog, usada também ao reprecificar itens no lançamento.
 */
export function precoProdutoPorListaTabela(produto: Produto, listaId?: number, tabelaId?: number): number {
  if (!produto) {
    return 0;
  }
  const precos = Array.isArray(produto.precos) ? produto.precos : [];
  const achar = (cond: (p: any) => boolean) => precos.find(cond)?.preco;

  if (listaId > 0 && tabelaId > 0) {
    const preco = achar(p => p?.listaId === listaId && p?.tabelaId === tabelaId);
    if (preco != null) { return preco; }
  }
  if (listaId > 0) {
    const preco = achar(p => p?.listaId === listaId);
    if (preco != null) { return preco; }
  }
  if (tabelaId > 0) {
    const preco = achar(p => p?.tabelaId === tabelaId);
    if (preco != null) { return preco; }
  }
  return produto.preco ?? 0;
}

/** Diretiva 134 "Obrigatório informe preço de tabela". */
export const D134_SOMENTE_AVISAR = 2;
export const D134_OBRIGATORIO = 3;

/**
 * Compara a lista/tabela escolhida na tela com as do cadastro do cliente. Só há divergência quando o
 * cliente tem lista/tabela própria (origem CADASTRO) — sem isso a diretiva 134 não tem com o que
 * comparar, igual ao desktop e ao trigger lancamento_integra_itens_before.
 *
 * @param tabelaId `undefined` para checar só a lista (tabela ainda não escolhida).
 * @returns a mensagem de divergência, ou null.
 */
export function divergenciaListaPrecoCliente(
  politica: ListaPrecoResolvida,
  listaId: number,
  tabelaId?: number
): string | null {
  if (!politica) {
    return null;
  }
  const listaCliente = politica.origemLista === 'CADASTRO' ? politica.fatListaPreco : null;
  const tabelaCliente = politica.origemTabela === 'CADASTRO' ? politica.fatListaPrecoTabela : null;

  if (listaCliente?.id && listaId && listaCliente.id !== listaId) {
    return `A Lista de Preço informada é diferente da Lista de Preço do cadastro do cliente `
      + `(${listaCliente.codigo ?? listaCliente.id} - ${(listaCliente.descricao ?? '').trim()}).`;
  }
  if (tabelaId !== undefined && tabelaCliente?.id?.tabelaId && tabelaId && tabelaCliente.id.tabelaId !== tabelaId) {
    return `A Tabela de Preço informada é diferente da Tabela de Preço do cadastro do cliente `
      + `(${tabelaCliente.id.tabelaId} - ${(tabelaCliente.descricao ?? '').trim()}).`;
  }
  return null;
}
